// extracted by mini-css-extract-plugin
module.exports = {"container":"Terms_container__3KQOj","text":"Terms_text__3EXh1","link":"Terms_link__34xDu"};